(function() {
  // Cargar variantes en window para que global.js las use
  if (window.location.pathname.includes('/products/')) {
    var handle = window.location.pathname.split('/products/')[1].split('?')[0];
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) { window.__productVariants = data.variants; });
  }

  // GRID
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    return originalFetch.apply(this, arguments).then(function(response) {
      if (typeof url === 'string' && url.includes('view=card-ajax')) {
        setTimeout(function() { updateGridPrices(); }, 0);
        setTimeout(function() { updateGridPrices(); }, 50);
        setTimeout(function() { updateGridPrices(); }, 150);
      }
      return response;
    });
  };

  function updateGridPrices() {
    document.querySelectorAll('card-variant-selects').forEach(function(selector) {
      var scriptTag = selector.querySelector('script[type="application/json"]');
      if (!scriptTag) return;
      var variants;
      try { variants = JSON.parse(scriptTag.textContent); } catch(e) { return; }
      if (!Array.isArray(variants)) return;
      var productId = selector.getAttribute('data-product');
      var priceContainer = document.getElementById('price-' + productId);
      if (!priceContainer) return;
      var checkedInputs = selector.querySelectorAll('input[type="radio"]:checked');
      var selectedOptions = Array.from(checkedInputs).map(function(i) { return i.value; });
      var match = variants.find(function(v) {
        return selectedOptions.every(function(opt, idx) {
          return v['option' + (idx + 1)] === opt;
        });
      });
      if (match) {
        var el = priceContainer.querySelector('[class*="price__main"], [class*="price__sale"]');
        if (el) el.textContent = '$' + (match.price / 100).toLocaleString('es-CO');
      }
    });
  }
})();